import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _ArchiveJournalEventButton;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import LinkButton from 'ui-kit/components/link-button';
import Component from '@glimmer/component';
import JournalEventModel from 'core/models/journal-event';
import { dropTask, timeout } from 'ember-concurrency';
import emberSwal from 'ui-kit/utils/ember-swal';
import WrButton from 'ember-wiser/components/wr/button';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
let ArchiveJournalEventButton = (_class = (_ArchiveJournalEventButton = class ArchiveJournalEventButton extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "deleteJournalEventTask", _buildTask(() => ({
      context: this,
      generator: function* (je1) {
        // This is just to help understand what's going on.
        yield timeout(200);
        yield je1.archive();
        this.args.afterArchived?.();
      }
    }), null, "deleteJournalEventTask", "drop"));
  }
  async confirmArchive(event1) {
    event1.stopPropagation();
    if (this.deleteJournalEventTask.isRunning) return;
    const result1 = await emberSwal.fire({
      title: this.args.confirmationTitle || 'Confirmer la suppression',
      text: this.args.additionalInformation || 'Cette opération ne peut pas être annulée.',
      icon: 'warning',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer'
    });
    if (result1.value) {
      this.deleteJournalEventTask.perform(this.args.journalEvent);
    }
  }
}, setComponentTemplate(precompileTemplate("\n    {{#if @wiser}}\n      <WrButton @icon=\"Trash\" @variant=\"outlined-mini\" {{on \"click\" this.confirmArchive}} ...attributes />\n    {{else}}\n      <LinkButton data-tooltip={{unless (has-block) \"Supprimer\"}} aria-label=\"archiver le JE\" {{on \"click\" this.confirmArchive}} ...attributes>\n        {{#if this.deleteJournalEventTask.isRunning}}\n          <i class={{concat \"notched circle loading icon\" @iconSize}}></i>\n        {{else}}\n          <i class={{concat \"trash alternate icon outline\" @iconSize}}></i>\n        {{/if}}\n        {{yield}}\n      </LinkButton>\n    {{/if}}\n  ", {
  strictMode: true,
  scope: () => ({
    WrButton,
    on,
    LinkButton,
    concat
  })
}), _ArchiveJournalEventButton), _ArchiveJournalEventButton), _applyDecoratedDescriptor(_class.prototype, "confirmArchive", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirmArchive"), _class.prototype), _class);
export { ArchiveJournalEventButton as default };